import { render, staticRenderFns } from "./results.vue?vue&type=template&id=667bf6fa&scoped=true&"
import script from "./results.vue?vue&type=script&lang=js&"
export * from "./results.vue?vue&type=script&lang=js&"
import style0 from "./results.vue?vue&type=style&index=0&lang=css&"
import style1 from "./results.vue?vue&type=style&index=1&id=667bf6fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667bf6fa",
  null
  
)

export default component.exports